import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class CLWorkLocationService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/CLWorkLocations`);
    }

}